
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns29b73ecd73cd3986a3a1ae0fca1a54ffen from './en.yaml'
            i18n.addResourceBundle('en', '29b73ecd73cd3986a3a1ae0fca1a54ff', flattenObject(ns29b73ecd73cd3986a3a1ae0fca1a54ffen), true, true);
        
        export default '29b73ecd73cd3986a3a1ae0fca1a54ff';
    